export type JobLogLevel = "CRITICAL" | "DEBUG" | "ERROR" | "INFO" | "WARNING";

export const JOB_LOG_LEVELS: JobLogLevel[] = ["CRITICAL", "ERROR", "WARNING", "INFO", "DEBUG"];

export const COUNTED_JOB_LOG_LEVELS = ["CRITICAL", "ERROR", "WARNING"] as const;

export type CountedJobLogLevel = (typeof COUNTED_JOB_LOG_LEVELS)[number];

export const countJobLogLevels = (lines: readonly { level?: string }[]): Record<CountedJobLogLevel, number> => {
  const counts: Record<CountedJobLogLevel, number> = { CRITICAL: 0, ERROR: 0, WARNING: 0 };
  lines.forEach((line) => {
    if (line.level === "CRITICAL" || line.level === "ERROR" || line.level === "WARNING") {
      counts[line.level] += 1;
    }
  });
  return counts;
};

export const jobLogLevelRank = (level?: string) => {
  if (!level) return JOB_LOG_LEVELS.length - 1;
  const index = JOB_LOG_LEVELS.findIndex((item) => item === level);
  if (index < 0) return JOB_LOG_LEVELS.length - 1;
  return index;
};

export const isLogVisibleForGranularity = (level: string | undefined, granularity: JobLogLevel) =>
  jobLogLevelRank(level) <= jobLogLevelRank(granularity);

export const jobLogLevelColorClass = (level?: string) => {
  if (level === "CRITICAL" || level === "ERROR") return "text-core-mystic-red-500";
  if (level === "WARNING") return "text-core-tangerine-500";
  if (level === "INFO") return "text-core-leaftech-blue-400";
  if (level === "DEBUG") return "text-lds-purpose-status-positive-subtle";
  return "text-lds-foreground-inverse";
};

export const jobLogLevelDotClass = (level: JobLogLevel) => {
  if (level === "CRITICAL" || level === "ERROR") return "bg-core-mystic-red-500";
  if (level === "WARNING") return "bg-core-tangerine-500";
  if (level === "INFO") return "bg-core-leaftech-blue-400";
  return "bg-lds-purpose-status-positive-subtle";
};

export const jobLogLevelBorderClass = (level?: string) => {
  if (level === "CRITICAL" || level === "ERROR") return "border-l-core-mystic-red-500";
  if (level === "WARNING") return "border-l-core-tangerine-500";
  if (level === "INFO") return "border-l-core-leaftech-blue-400";
  return "border-l-lds-purpose-status-positive-subtle";
};

export const formatJobLogTime = (value?: string) => {
  if (!value) return;
  return value.replace("T", " ").replace(/Z$/, "");
};

export const toScriptFileName = (moduleName?: string) => {
  if (!moduleName) return;
  if (moduleName.endsWith(".py")) return moduleName;
  return `${moduleName}.py`;
};
